import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const notificationBarDefaultVariants = {
  "variant": "info"
}
const notificationBarCompoundVariants = []

const notificationBarSlotNames = [
  [
    "root",
    "NotificationBar__root"
  ],
  [
    "icon",
    "NotificationBar__icon"
  ],
  [
    "content",
    "NotificationBar__content"
  ],
  [
    "action",
    "NotificationBar__action"
  ],
  [
    "dismiss",
    "NotificationBar__dismiss"
  ]
]
const notificationBarSlotFns = /* @__PURE__ */ notificationBarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, notificationBarDefaultVariants, getSlotCompoundVariant(notificationBarCompoundVariants, slotName))])

const notificationBarFn = memo((props = {}) => {
  return Object.fromEntries(notificationBarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const notificationBarVariantKeys = [
  "variant"
]
const getVariantProps = (variants) => ({ ...notificationBarDefaultVariants, ...compact(variants) })

export const notificationBar = /* @__PURE__ */ Object.assign(notificationBarFn, {
  __recipe__: false,
  __name__: 'notificationBar',
  raw: (props) => props,
  variantKeys: notificationBarVariantKeys,
  variantMap: {
  "variant": [
    "info",
    "success",
    "warning",
    "danger"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, notificationBarVariantKeys)
  },
  getVariantProps
})